import exclusiveInterfaces from './interface';

// for development use
const useDummyInterfaces = false;

const interfaces = useDummyInterfaces
  ? require('mocks/government-revenue/public').default
  : window.API.wrap(exclusiveInterfaces, 'xhrGovernmentRevenuePublic');

export default interfaces;
